import { wait } from "../../utils/utils"

const RETRIES_DELAY = [1000, 3000, 5000, 10000];

export const fetchEndpointRetry = (data, lang, retryNumber = 0) => new Promise(async (resolve, reject) => {
    try {
        // const headers = {
        //     'Content-Type': 'application/json',
        //     'Access-Control-Allow-Origin': '*',
        //     'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS'
        // }
        const queryParams = data.queryParams?.map(param => `${param.key}=${param.value}`).join('&').replace("LANG", lang);

        const fetchOptions = {
            method: data.method,
            credentials: "include",
            cors: "no-cors",
        }
        if (data.method === "Post") {
            fetchOptions.headers = {
                'content-type': 'application/json', 'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS'
            };
            fetchOptions.body = data.body
        }
        const res = await fetch(`${window.config.baseApiUrl}${data.link}${queryParams ? `?${queryParams}`:""}`, fetchOptions);
        // const res = await fetch(`https://localhost:7051${data.link}${queryParams ? `?${queryParams}`:""}`, fetchOptions);
        // todo create body 
        if (res && res.ok) {
            const resJson = await res.json();
            resolve(resJson);
        }
        else {
            throw new Error(`fetch to ${data.url} faild with status ${res && res.status}`);
        }
    }

    catch (e) {
        if (retryNumber <= 3) {
            try {
                await wait(RETRIES_DELAY[retryNumber]);
                const res = await fetchEndpointRetry(data, lang, retryNumber + 1);
                resolve(res);
            }
            catch (e) {
                reject(e);
            }
        }
        else {
            reject(e);
        }
    }
})
